import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const SCRIPT_RUN_API_NAME: string = 'script-run';
export const SCRIPT_RUN_API_ENDPOINT: string = environment.API_BASE_PATH + '/company/script-run';

@Injectable({
  providedIn: 'root',
})
export class ScriptRunService {
  constructor() {}

  create(script_type: string, text_file: string): Observable<any> {
    const api_name: string = SCRIPT_RUN_API_NAME;
    const path: string = '';
    const init = {
      response: true,
      body: { script_type, text_file },
    };
    return from(API.post(api_name, path, init));
  }
}
